module.exports = __webpack_public_path__ + "static/media/Gustavo Pessini‎ 01.1da9bf30.jpg";